import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { Observable } from "rxjs";

export enum ApplicationType {
    Web = 1,
    AdminApi = 4,
    Worker = 2,
    Runner = 3,
    Backtesting = 5,
    ConditionalOrders = 6,
}

export const APPLICATION_TYPES: { value: ApplicationType; label: string }[] = [
    { value: ApplicationType.Web, label: "Web API" },
    { value: ApplicationType.AdminApi, label: "Admin API" },
    { value: ApplicationType.Worker, label: "Worker" },
    { value: ApplicationType.Runner, label: "Trading runner" },
    { value: ApplicationType.Backtesting, label: "Backtesting" },
    { value: ApplicationType.ConditionalOrders, label: "Conditional orders" },
];

@Injectable({ providedIn: "root" })
export class LogsService {
    private readonly http = inject(HttpClient);

    downloadAppLog(applicationType: ApplicationType, from: string, to: string): Observable<Blob> {
        const body: DownloadLogsRequest = { applicationType, from, to };
        return this.http.post("/logs", body, { responseType: "blob" });
    }
}

export type DownloadLogsRequest = {
    applicationType: ApplicationType;
    from: string;
    to: string;
};
